<template>
  <b-container class="mobile-navbar" fluid>
    <div class="header-container-inner">
      <div class="d-flex gx-5">
        <div class="avatar-holder">
          <router-link :class="!disabledNavbar ? 'icons' : 'icons-disabled'" :to="{ name: 'UserProfileMenu' }" exact>
            <img class="profileImg" :src="userInfo.profile_picture" alt />
          </router-link>
        </div>

        <div class="search-con">
          <i class="fa fa-search search-icon"></i>
          <input type="text" class="search-bar" placeholder="Search" @keyup.enter="handleSearch()"
            v-model="searchKeyword" />
        </div>
      </div>

      <div class="d-flex gx-5">
        <div class="logo-holder">
          <img class="logoImg" :src="require('@/assets/logo/logo_small.png')" alt />
        </div>
        <b-navbar-toggle target="nav-left">
          <template #default="{ expanded }">
            <i v-if="expanded" class="fa fa-times"></i>
            <i v-else class="fa fa-bars"></i>
          </template>
        </b-navbar-toggle>
      </div>
      <b-collapse id="nav-left" is-nav>
        <b-navbar-nav class="navbar_links">
          <li class="nav-item dropdown" style="display: inline-block">
            <router-link to="/personal-wall" target="_self" class="main-link" dropright data-toggle="dropdown">
              <img  :src="$route.path === '/personal-wall'
                ? require('@/assets/menuIcons/icons_top__Home__hover.png')
                : require(`@/assets/menuIcons/${homeIcon}`)" alt="home" class="menu-icon" /> Home
            </router-link>
          </li>
          <li class="nav-item dropdown" style="display: inline-block">
            <router-link :to="{ name: 'ccAllEvents' }" target="_self" class="main-link" dropright
              data-toggle="dropdown">
              <img :src="$route.path === '/all-events'
                ? require('@/assets/menuIcons/icons_top__Events__hover.png')
                : require(`@/assets/menuIcons/${eventsIcon}`)
                " alt="events" class="menu-icon" /> Events
            </router-link>
          </li>
          <li @mouseover="myEventsIcon = 'icons_top__Events__hover.png'"
            @mouseout="myEventsIcon = 'icons_top__Events.png'" class="nav-item dropdown" style="display: inline-block">
            <router-link :to="{ name: 'ccMyEvents' }" target="_self" class="main-link" dropright data-toggle="dropdown">
              <img :src="$route.path === '/my-events'
                ? require('@/assets/menuIcons/icons_top__Events__hover.png')
                : require(`@/assets/menuIcons/${myEventsIcon}`)
                " alt="events" class="menu-icon" /> My Events
            </router-link>
          </li>
          <li class="nav-item network dropdown" style="display: inline-block">
            <a target="_self" class="main-link" dropright data-toggle="dropdown" @click="isDropdownShown = !isDropdownShown">
              <img :src="$route.path === '/network'
                ? require('@/assets/menuIcons/icons_top__Network__hover.png')
                : require(`@/assets/menuIcons/icons_top__Network.png`)
                " alt="network" class="menu-icon" /> NetWorks
                <div :class="`arrow-${!isDropdownShown ? 'down': 'up'}`"></div>
            </a>
            <div :class="`dropdown-content ${isDropdownShown ? 'd-flex' : 'd-none'}`">
              <router-link :to="{ name: 'network' }" exact>
                <img :src="$route.path === '/network'
                  ? require('@/assets/menuIcons/icons_top__Network__hover.png')
                  : require(`@/assets/menuIcons/icons_top__Network.png`)
                  " alt="network" class="menu-icon" /> My Network</router-link>
              <router-link :to="{ name: 'MembersList' }" exact>
                <img :src="$route.path === '/members'
                  ? require('@/assets/menuIcons/icons_top__Members__hover.png')
                  : require(`@/assets/menuIcons/${membersIcon}`)
                  " alt="members" class="menu-icon" />
                Global Directory
              </router-link>
            </div>
          </li>
          <li class="nav-item dropdown" style="display: inline-block">
            <router-link :to="{ name: 'MediaArchive' }" target="_self" class="main-link" dropright
              data-toggle="dropdown">
              <img :src="$route.path === '/media-archive'
                ? require('@/assets/menuIcons/icons_top__Archive__hover.png')
                : require(`@/assets/menuIcons/${archiveIcon}`)
                " alt="media" class="menu-icon" /> Media Archive
            </router-link>
          </li>

          <li class="nav-item dropdown" style="display: inline-block">
            <router-link :to="{ name: 'MediaChannels' }" target="_self" class="main-link" dropright
              data-toggle="dropdown">
              <img :src="$route.path === '/media-channels'
                ? require('@/assets/menuIcons/icons_top__Media__hover.png')
                : require(`@/assets/menuIcons/${mediaIcon}`)
                " alt="media" class="menu-icon" /> Media Channels
            </router-link>
          </li>
          <li class="nav-item dropdown" style="display: inline-block">
            <router-link :to="{ name: 'Messages' }" target="_self" class="main-link" dropright data-toggle="dropdown">
              <img :src="$route.path === '/messages'
                ? require('@/assets/menuIcons/icons_top__Messages__hover.png')
                : require(`@/assets/menuIcons/${messagesIcon}`)
                " alt="messages" class="menu-icon" /> Messages <i class="nav-bar-notification-icons"
                v-if="unreadMessagesCount">{{
                  unreadMessagesCount
                }}</i>
            </router-link>
          </li>
          <li class="nav-item dropdown" style="display: inline-block">
            <router-link :to="{ name: 'AllNotifications' }" target="_self" class="main-link" dropright
              data-toggle="dropdown">
              <img :src="$route.path === '/notifications'
                ? require('@/assets/menuIcons/icons_top__Notifications__hover.png')
                : require(`@/assets/menuIcons/${notificationsIcon}`)
                " alt="notifications" class="menu-icon" /> Notifications <i class="nav-bar-notification-icons"
                v-if="newNotifsCount">{{
                  newNotifsCount
                }}</i>
            </router-link>
          </li>
          <li class="nav-item dropdown" style="display: inline-block">
            <div @click.prevent="logOut" class="main-link">
              <img :src="$route.path === '/messages'
                ? require('@/assets/menuIcons/icons_top__Logout__white.png')
                : require(`@/assets/menuIcons/${logoutIcon}`)
                " alt="messages" class="menu-icon" /> Log out
            </div>
          </li>
        </b-navbar-nav>
      </b-collapse>
    </div>

    <b-row v-if="mobileBanners.length">
      <b-col cols="12">
        <Advertisement class="left-Advertisement" :imgWidth="'100vw'" :imgHeight="'8vh'" :banners="mobileBanners" />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Advertisement from '../advertisement/Advertisement.vue';
import getIDfromURL from '../../utils/getIDfromURL';

export default {
  name: 'MobileNavbar',
  components: { Advertisement },
  data() {
    return {
      users: [],
      mobileBanners: [],
      page: 1,
      notificationCount: 0,
      searchIcon: 'icons_top__Search.png',
      myEventsIcon: 'icons_top__Events.png',
      searchKeyword: '',
      isMenuShown: false,
      isDropdownShown: false,
    };
  },
  props: {
    disabledNavbar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
      newNotifsCount: 'notifications/newNotifsCount',
      unreadMessagesCount: 'messages/unreadMessagesCount',
    }),
    archiveIcon() {
      return 'icons_top__Archive.png';
    },
    messagesIcon() {
      return this.$route.path === '/messages' ? 'icons_top__Messages__white.png' : 'icons_top__Messages.png';
    },
    eventsIcon() {
      return this.$route.path === '/all-events' ? 'icons_top__Events__white.png' : 'icons_top__Events.png';
    },
    homeIcon() {
      return this.$route.path === '/personal-wall' ? 'icons_top__Home__white.png' : 'icons_top__Home.png';
    },
    mediaIcon() {
      return this.$route.path === '/media-channels' ? 'icons_top__Media__white.png' : 'icons_top__Media.png';
    },
    membersIcon() {
      return this.$route.path === '/members' ? 'icons_top__Members__white.png' : 'icons_top__Members.png';
    },
    notificationsIcon() {
      return this.$route.path === '/notifications' ? 'icons_top__Notifications__white.png' : 'icons_top__Notifications.png';
    },
    networkIcon() {
      return this.$route.path === '/network' ? 'icons_top__Network__white.png' : 'icons_top__Network.png';
    },
    logoutIcon() {
      return this.$route.path === '/' ? 'icons_top__Logout__white.png' : 'icons_top__Logout.png';
    },
  },
  async mounted() {
    await this.getUnreadMessagesCount();
    await this.fetchAdvertisementBanners('mobile').then(res => (this.mobileBanners = res));
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === 'nav-left') {
        this.isMenuShown = isJustShown;
        if (isJustShown) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'auto';
        }
      }
    })
  },
  methods: {
    ...mapActions({
      userLogout: 'auth/userLogout',
      getUnreadMessagesCount: 'messages/getUnreadMessagesCount',
      fetchAdvertisementBanners: 'advertisement/fetchAdvertisementBanners',
    }),
    logOut() {
      this.userLogout();
      this.$router.push({ name: 'PublicEvents' });
    },
    getId(url) {
      return getIDfromURL(url);
    },
    handleSearch() {
      this.$root.$emit('bv::toggle::collapse', 'nav-left');
      this.$router.push({ name: 'GlobalSearch', query: { query: this.searchKeyword } });
      this.searchKeyword = '';
    },
  },
  watch: {
    $route(to, from) {
      // check if bv collapse is showing then hide
      if (this.isMenuShown) this.$root.$emit('bv::toggle::collapse', 'nav-left');
    },
  },
  updated() {
  //   make .mobile-navbar fixed on scroll
    window.onscroll = function() {
      const navbar = document.querySelector('.mobile-navbar');
      // check if not messages page
      if (!window.location.pathname.includes('/messages/')) {
        if (navbar) {
          if (window.pageYOffset > 0) {
            navbar.style.position = 'fixed';
          } else {
            navbar.style.position = 'relative';
          }
        }
      }
    };
  },
  beforeDestroy() {
    window.onscroll = null;
  },
};
</script>
<style scoped src="./MobileNavbar.css"></style>
